import { useQuery } from "@tanstack/react-query";
import apiClient from "@/modules/request.module.v2";
import { useCompanyIdFromUrl } from "@/hooks/companies/useCompanyIdFromUrl";
const useSubscription = () => {
  const companyId = useCompanyIdFromUrl();

  return useQuery({
    enabled: !!companyId,
    queryKey: ["subscription", companyId],
    queryFn: () => {
      return apiClient.get(`subscriptions/`, {
        params: {
          companyId,
        },
      });
    },
  });
};

export { useSubscription };
